// extracted by mini-css-extract-plugin
export default {"address":"_2wFMSUosYQ7x3hr4vqTcpB"};